var _g, _g2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _circle, _path, _rect8, _rect9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProspectingLead2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 32,
    viewBox: "0 0 255 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_496_21568)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 10,
    width: 220,
    height: 120,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.25,
    y: 10.25,
    width: 219.5,
    height: 119.5,
    rx: 5.75,
    stroke: "#EBEDF5",
    strokeWidth: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_496_21568)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 33,
    width: 192.873,
    height: 38.9844,
    rx: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.1,
    y: 33.1,
    width: 192.673,
    height: 38.7844,
    rx: 2.9,
    stroke: "#DDE3EC",
    strokeWidth: 0.2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49.8535,
    y: 47.0234,
    width: 34.6177,
    height: 3.28227,
    rx: 1.64114,
    fill: "#E4E6EF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 80,
    width: 134,
    height: 3,
    rx: 1.5,
    fill: "#E4E6EF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 111,
    width: 87,
    height: 3,
    rx: 1.5,
    fill: "#E4E6EF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 49.8535,
    y: 54.6797,
    width: 41.8297,
    height: 3.28227,
    rx: 1.64114,
    fill: "#E4E6EF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 88,
    width: 161,
    height: 3,
    rx: 1.5,
    fill: "#E4E6EF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 103,
    width: 106,
    height: 3,
    rx: 1.5,
    fill: "#E4E6EF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 13.3691,
    y: 39.3828,
    width: 27.0294,
    height: 26.2188,
    rx: 2,
    fill: "#E4E6EF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 83,
    r: 23,
    fill: "#E4E6EF",
    fillOpacity: 0.2,
    stroke: "#E1E3EC",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M227.152 122.496C227.933 123.277 229.2 123.277 229.981 122.496C230.762 121.715 230.762 120.449 229.981 119.668L227.152 122.496ZM206.652 101.996L227.152 122.496L229.981 119.668L209.481 99.1678L206.652 101.996Z",
    fill: "#E1E3EC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 18,
    width: 204,
    height: 6,
    rx: 3,
    fill: "#E4E6EF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 18,
    width: 112,
    height: 6,
    rx: 3,
    fill: "#4F46E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_496_21568",
    x: 11,
    y: 0,
    width: 244,
    height: 144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.137255 0 0 0 0 0.243137 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_496_21568"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_496_21568",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_496_21568",
    x: 0,
    y: 29,
    width: 204.873,
    height: 50.9844,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.137255 0 0 0 0 0.243137 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_496_21568"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_496_21568",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProspectingLead2);
export default __webpack_public_path__ + "static/media/ProspectingLead2.6641334326e4b081a9ed8c6356b332af.svg";
export { ForwardRef as ReactComponent };